import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { images } from '../data/images';
import { practice } from '../data/site';
import { SectionLabel } from './ui/SectionLabel';
import { Reveal } from './ui/Reveal';
export function InvisalignSection() {
  return <section id="invisalign" className="scroll-mt-24 bg-white py-24 lg:py-40" data-id="element-346" data-mp="fd49nrau4otv">
      <div className="mx-auto grid max-w-shell items-center gap-14 px-5 sm:px-8 lg:grid-cols-2 lg:gap-20 lg:px-12" data-id="element-347" data-mp="kebjrx0ga03p">
        <Reveal className="order-2 lg:order-1" data-id="element-348" data-mp="181teo1f0heaw">
          <SectionLabel data-id="element-349" data-mp="1d1o5k4yse3vy">Invisalign in Miami Lakes</SectionLabel>
          <h2 className="font-display mt-6 text-[clamp(2rem,4.2vw,3.3rem)] leading-[1.06] text-ink" data-id="element-350" data-mp="z2y82o822272">
            $3,000 Off
            <br data-id="element-351" data-mp="133rxjm15bp22" />
            <span className="font-display-em" data-id="element-352" data-mp="1338e20vukslx">Clear Aligners</span>
          </h2>
          <p className="mt-7 max-w-[52ch] text-[16.5px] leading-[1.85] text-ink/70" data-id="element-353" data-mp="3jsxcwotszv5g">
            New patients get a free consult and a 3D scan of your new smile. Payment plans
            available. Limited spots this month.
          </p>

          <ul className="mt-10 flex flex-wrap gap-x-10 gap-y-4 border-t border-ink/10 pt-7 text-[15px] text-ink/70" data-id="element-354" data-mp="25stfgfry2z9k">
            {['Free consultation', '3D scan of your new smile', 'Payment plans available'].map(item => <li key={item} className="flex items-center gap-2.5" data-id="element-355" data-mp="2arwdvhdf678k">
                  <span aria-hidden="true" className="h-1 w-1 rounded-full bg-accent" data-id="element-356" data-mp="2au0osj9qk6ic" />
                  {item}
                </li>)}
          </ul>

          <a href={practice.bookingUrl} target="_blank" rel="noreferrer" className="group mt-10 inline-flex min-h-[54px] items-center gap-2.5 rounded-[10px] bg-ink px-7 text-[15px] font-medium text-white transition-colors hover:bg-ink-char" data-id="element-357" data-mp="2jrt2jizt763m">
            Get Offer
            <span className="hover-arrow" data-id="element-358" data-mp="37fkgss4wtt7j">
              <ArrowRightIcon aria-hidden="true" className="h-4 w-4" strokeWidth={1.75} data-id="element-359" data-mp="32jlpows75x3f" />
            </span>
          </a>
        </Reveal>

        <Reveal delay={0.08} className="order-1 lg:order-2" data-id="element-360" data-mp="2078x33j8pnku">
          <div className="aspect-[4/5] overflow-hidden rounded-[14px] bg-paper-off" data-id="element-361" data-mp="255k83hl9u44n">
            <img src={images.invisalign} alt="Clinician holding two clear aligners at Lima Dental Group in Miami Lakes" loading="lazy" className="h-full w-full object-cover object-[center_35%] saturate-[0.55] contrast-[1.04]" data-id="element-362" data-mp="295kkyxsq279l" />
          </div>
        </Reveal>
      </div>
    </section>;
}